import { api } from "./api";
import type { PaginatedResponse, BackgroundJobDataType } from "types/DataTypes";

type GetBackgroundJobsArgs = {
  filters?: Record<string, unknown>;
};

type PatchBackgroundJobArgs = {
  id: number | string;
  data: Partial<BackgroundJobDataType>;
};

export const backgroundJobAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getBackgroundJobs: build.query<
      PaginatedResponse<BackgroundJobDataType>,
      GetBackgroundJobsArgs
    >({
      query: ({ filters = {} }) => ({
        url: `api/v1/background-jobs`,
        method: "GET",
        params: {
          ...(filters && { ...filters }),
        },
      }),
      providesTags: ["BackgroundJobs"],
    }),
    getBackgroundJobById: build.query<BackgroundJobDataType, number>({
      query: (id) => ({
        url: `api/v1/background-jobs/${id}/`,
        method: "GET",
      }),
      providesTags: ["BackgroundJobs"],
    }),
    patchBackgroundJobById: build.mutation<
      BackgroundJobDataType,
      PatchBackgroundJobArgs
    >({
      query: ({ id, data }) => ({
        url: `api/v1/background-jobs/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["BackgroundJobs"],
    }),
    // only available for jobs the API reports as `can_retry` (currently the
    // failed AI sort/summary types) — the server rejects anything else
    retryBackgroundJobById: build.mutation<BackgroundJobDataType, number>({
      query: (id) => ({
        url: `api/v1/background-jobs/${id}/retry/`,
        method: "POST",
      }),
      invalidatesTags: ["BackgroundJobs"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBackgroundJobsQuery,
  useGetBackgroundJobByIdQuery,
  usePatchBackgroundJobByIdMutation,
  useRetryBackgroundJobByIdMutation,
} = backgroundJobAPI;
